/**
 * Constants para o Formulário Interativo
 */

export const FORM_ID = 'cmb9s9qqh000am25x2ni8uxar';
export const FORM_NAME = 'Pré cadastros X do Infinito';

export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[\d\s\-().+]+$/,
  CPF: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
  CEP: /^\d{5}-?\d{3}$/,
  RG: /^\d{1,15}$/,
  INSTAGRAM: /^@?[\w.]{1,30}$/,
  DATE: /^(\d{2})\/(\d{2})\/(\d{4})$/,
};

export const MESSAGES = {
  REQUIRED_FIELD: 'Este campo é obrigatório',
  INVALID_EMAIL: 'Email inválido',
  INVALID_PHONE: 'Telefone inválido',
  INVALID_CPF: 'CPF inválido',
  INVALID_CEP: 'CEP inválido',
  INVALID_DATE: 'Data inválida',
  INVALID_RG: 'RG inválido',
  INVALID_INSTAGRAM: 'Instagram inválido',
  FORM_SUBMITTED: 'Formulário enviado com sucesso!',
  FORM_ERROR: 'Erro ao enviar formulário',
  NETWORK_ERROR: 'Erro de conexão',
};

export const RESIDENCES = [
  { label: 'Própria', value: 'own' },
  { label: 'Alugada', value: 'rented' },
  { label: 'Familiar', value: 'family' },
];

export const MARITAL_STATUS = [
  { label: 'Solteiro(a)', value: 'single' },
  { label: 'Casado(a)', value: 'married' },
  { label: 'União Estável', value: 'stable-union' },
  { label: 'Divorciado(a)', value: 'divorced' },
  { label: 'Viúvo(a)', value: 'widowed' },
];

export const NATIONALITIES = [
  { label: 'Brasileira', value: 'brazilian' },
  { label: 'Portuguesa', value: 'portuguese' },
  { label: 'Outra', value: 'other' },
];

export const SCHOLAR_LEVELS = [
  { label: 'Fundamental Incompleto', value: 'fundamental-incomplete' },
  { label: 'Fundamental Completo', value: 'fundamental-complete' },
  { label: 'Médio Incompleto', value: 'medium-incomplete' },
  { label: 'Médio Completo', value: 'medium-complete' },
  { label: 'Superior Incompleto', value: 'superior-incomplete' },
  { label: 'Superior Completo', value: 'superior-complete' },
  { label: 'Pós-graduação', value: 'postgraduate' },
];

export const INCOME_RANGES = [
  { label: 'Até R$ 1.000', value: 'up-to-1000' },
  { label: 'R$ 1.000 - R$ 2.000', value: '1000-2000' },
  { label: 'R$ 2.000 - R$ 3.000', value: '2000-3000' },
  { label: 'R$ 3.000 - R$ 5.000', value: '3000-5000' },
  { label: 'R$ 5.000 - R$ 10.000', value: '5000-10000' },
  { label: 'Acima de R$ 10.000', value: 'above-10000' },
];

// Ordem dos steps no formulário
export const STEP_ORDER = [
  'step0_inicio',
  'step1_cidade',
  'step2_nome',
  'step3_email',
  'step4_whatsapp',
  'step5_nascimento',
  'step6_nacionalidade',
  'step7_rg',
  'step8_cpf',
  'step9_restricoes',
  'step21_mae',
  'step9_restricoes_detalhes',
  'step10_revendedora',
  'step11_estadocivil',
  'step22_educacao',
  'step12_endereco',
  'step13_residencia',
  'step14_filhos',
  'step15_emprego',
  'step16_renda',
  'step17_cartao',
  'step17A_veiculo',
  'step_adicional_objetivo_lucro',
  'step18_instagram',
  'step19_ref_familar_1',
  'step20_ref_familiar_2',
  'step20A_ref_comercial',
  'step20B_motivacao_embaixadora',
  'step20C_interesse_xizinha',
  'step20D_aprendizado_app',
  'step20E_tecnologia_redes',
  'step20E1_entrevista',
  'step20E2_treinamento',
  'step20F_contrato_responsabilidade',
  'step20G_duvidas',
  'step22_regra_final',
  'step23_finalizacao',
] as const;

// Estados brasileiros
export const ESTADOS_BR = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
  'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
  'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
];
